// Données des soins pour CotIdel
// Chaque soin mappe vers un mot-clé reconnu par le moteur NGAP

export interface CareItem {
  id: string;
  label: string;
  keyword: string; // mot-clé injecté dans la description pour le moteur
  isHeader?: boolean; // sous-titre visuel non sélectionnable
}

export interface CareCategory {
  id: string;
  name: string;
  icon: string;
  items: CareItem[];
}

export const CARE_CATEGORIES: CareCategory[] = [
  {
    id: 'soins-bsi',
    name: 'Soins BSI',
    icon: 'ri-user-heart-line',
    items: [
      { id: 'bsi-change', label: 'Change / protection', keyword: 'change change protection incontinence incontinance nursing' },
      { id: 'bsi-bsa', label: 'BSA — Pilulier', keyword: 'BSA dépendance légère GIR 4 forfait léger' },
      { id: 'bsi-bsb', label: 'BSB — Intermédiaire', keyword: 'BSB dépendance intermédiaire GIR 3 forfait intermédiaire' },
      { id: 'bsi-bsc', label: 'BSC — Lourd', keyword: 'BSC dépendance lourde GIR 1 GIR 2 forfait lourd grabataire' },
    ],
  },
  {
    id: 'diabete',
    name: 'Diabète',
    icon: 'ri-heart-pulse-line',
    items: [
      { id: 'diab-glycemie', label: 'Glycémie', keyword: 'surveillance glycémique dextro diabète' },
      { id: 'diab-injection', label: 'Injection insuline', keyword: 'insuline injection diabète' },
      { id: 'diab-insuline-lente', label: 'Insuline lente', keyword: 'insuline lente le matin et le soir' },
      { id: 'diab-insuline-2', label: '2e insuline (2e ligne AMX)', keyword: 'insuline deuxième injection insuline différente' },
      { id: 'diab-surveillance-hebdo', label: 'Séance hebdo. surveillance clinique (>75 ans, 30 min) — AMI 4', keyword: 'surveillance clinique hebdomadaire séance hebdomadaire surveillance patient plus de 75 ans' },
    ],
  },
  {
    id: 'surveillance',
    name: 'Surveillance',
    icon: 'ri-pulse-line',
    items: [
      { id: 'surv-administration', label: 'Administration traitement', keyword: 'administration de traitement' },
      { id: 'surv-prado', label: 'PRADO (retour à domicile)', keyword: 'PRADO programme retour à domicile surveillance post-hospitalisation' },
      { id: 'surv-posthosp', label: 'Post-hospitalisation', keyword: 'surveillance post-hospitalisation renforcée' },
      { id: 'surv-postop', label: 'Séance de surveillance clinique postopératoire (AMI 3,9)', keyword: 'surveillance clinique postopératoire' },
    ],
  },
  {
    id: 'pansements',
    name: 'Pansements',
    icon: 'ri-heart-pulse-line',
    items: [
      { id: 'pans-simple', label: 'Pansement simple (AMI 2,02)', keyword: 'pansement simple pansement courant' },
      { id: 'pans-ppnc', label: 'PPNC — Plaie non chirurgicale (AMI 2,02)', keyword: 'PPNC pansement plaie non chirurgicale' },
      { id: 'pans-ppcs', label: 'PPCS — Plaie chirurgicale simple (AMI 2,02)', keyword: 'PPCS pansement plaie chirurgicale simple' },
      { id: 'pans-tracheotomie', label: 'Pansement de trachéotomie (AMI 3)', keyword: 'pansement tracheotomie AMI 3' },
      { id: 'pans-postop', label: 'Pansement postopératoire étendu / varices (AMI 3)', keyword: 'pansement plaies opératoires étendues multiples abdominoplastie chirurgie mammaire pansement postopératoire exérèses multiples varices ligatures veines perforantes stripping' },
      { id: 'pans-compression', label: 'Pansement avec compression (AMI 5,1)', keyword: 'pansement avec compression bande compressive contention forte' },
      { id: 'pans-brulures', label: 'Brûlures — radiothérapie ou thermique/chimique (AMI 4)', keyword: 'pansement lourd brûlure radiothérapie surface supérieure 2 pourcent AMI 4 brûlure étendue plaie chimique thermique surface supérieure 5 pourcent AMI 4' },
      { id: 'pans-ulcere-escarre', label: 'Ulcère, escarre ou greffe cutanée (AMI 4)', keyword: 'pansement lourd ulcère étendu greffe cutanée surface supérieure 60 cm2 AMI 4 escarre profonde étendue muscles tendons AMI 4' },
      { id: 'pans-autres-complexes', label: 'Méchage, fistule, amputation ou perte de substance (AMI 4)', keyword: 'pansement lourd méchage irrigation AMI 4 fistule digestive AMI 4 amputation détersion épluchage régularisation AMI 4 perte substance traumatique néoplasique lésions profondes sous aponévrotiques musculaires tendineuses osseuses AMI 4' },
      { id: 'pans-bilan-initial', label: 'Bilan initial pansements lourds (AMI 11)', keyword: 'bilan initial pansement lourd bilan initial pansements lourds bilan initial pansement complexe bilan initial pansements complexes évaluation initiale pansement lourd évaluation initiale pansement complexe AMI 11' },
    ],
  },
  {
    id: 'injections',
    name: 'Injections',
    icon: 'ri-syringe-line',
    items: [
      { id: 'inj-sc', label: 'Sous-cutanée', keyword: 'héparine injection sous-cutanée anticoagulant' },
      { id: 'inj-im', label: 'Intramusculaire', keyword: 'injection intramusculaire' },
      { id: 'inj-iv', label: 'Intraveineuse', keyword: 'injection intraveineuse antibiotique IV' },
      { id: 'inj-vaccin-prescrit', label: 'Vaccin avec prescription (AMI 2,4)', keyword: 'vaccin avec prescription prescrit' },
      { id: 'inj-vaccin-sans-presc', label: 'Vaccin sans prescription / obligatoire (AMI 3,05)', keyword: 'vaccin sans prescription vaccin obligatoire' },
      { id: 'inj-vaccin', label: 'Vaccin (type à préciser)', keyword: 'vaccin vaccination' },
    ],
  },
  {
    id: 'perfusions',
    name: 'Perfusions',
    icon: 'ri-drop-line',
    items: [
      { id: 'perf-pose', label: 'Organisation surveillance (AMI 4 — hors jour pose/retrait)', keyword: 'organisation surveillance perfusion longue hors pose surveillance journalière perfusion' },
      { id: 'perf-depose', label: 'Dépose / arrêt perfusion > 24h (AMI 5)', keyword: 'dépose perfusion arrêt définitif perfusion plus de 24h débranchement définitif perfusion longue durée AMI 5' },
      { id: 'perf-courte', label: 'Perfusion courte (≤1h)', keyword: 'perfusion courte sous surveillance 45min' },
      { id: 'perf-heure-supp', label: 'Heure supplémentaire surveillance continue (AMI 6)', keyword: 'heure supplémentaire surveillance continue perfusion courte AMI 6' },
      { id: 'perf-longue', label: 'Perfusion longue (>1h)', keyword: 'perfusion longue plusieurs heures' },
      { id: 'perf-courte-c', label: 'Perfusion courte (cancéreux)', keyword: 'perfusion courte cancéreux immunodéprimé' },
      { id: 'perf-longue-c', label: 'Perfusion longue (cancéreux)', keyword: 'perfusion longue cancéreux immunodéprimé' },
      { id: 'perf-retrait-24h', label: 'Retrait perfusion < 24h (AMI 4,1)', keyword: 'retrait perfusion moins de 24h AMI 4,1' },
      { id: 'perf-flacon', label: 'Changement de flacon (AMI 4,1)', keyword: 'changement de flacon perfusion longue AMI 4,1' },
      { id: 'perf-debit', label: 'Surveillance du débit (AMI 4,1)', keyword: 'surveillance du débit perfusion longue AMI 4,1' },
      { id: 'perf-branchement-y', label: 'Branchement en Y (AMI 4,1)', keyword: 'branchement en Y perfusion longue AMI 4,1' },
      { id: 'perf-deplacement', label: 'Déplacement de la perfusion (AMI 4,1)', keyword: 'déplacement de la perfusion longue AMI 4,1' },
      { id: 'perf-complication', label: 'Appel suite à complication (AMI 4,1)', keyword: 'appel suite à complication perfusion AMI 4,1' },
      { id: 'perf-debranche-temp', label: 'Débranchement temporaire < 24h (AMI 4,1)', keyword: 'débranchement temporaire perfusion moins de 24h AMI 4,1' },
      { id: 'perf-midline-picc', label: 'Retrait Midline / Picc Line (AMI 5)', keyword: 'retrait midline dépose picc line ablation picc arrêt définitif perfusion pansement changement valve AMI 5' },
    ],
  },
  {
    id: 'prelevements',
    name: 'Prélèvements',
    icon: 'ri-test-tube-line',
    items: [
      { id: 'prev-sanguin', label: 'Sanguin', keyword: 'prise de sang prélèvement veineux bilan sanguin' },
      { id: 'prev-urinaire', label: 'Urinaire', keyword: 'ECBU prélèvement urinaire' },
      { id: 'prev-pcr', label: 'PCR', keyword: 'prélèvement PCR test covid' },
      { id: 'prev-inr', label: 'INR capillaire', keyword: 'INR prélèvement capillaire coagulation' },
    ],
  },
  {
    id: 'soins-tech',
    name: 'Soins techniques',
    icon: 'ri-stethoscope-line',
    items: [
      { id: 'tech-sonde-uri-femme', label: 'Sonde urinaire — Femme (AMI 3)', keyword: 'pose sonde urinaire femme sondage femme' },
      { id: 'tech-sonde-uri-homme', label: 'Cathétérisme urétral — Homme (AMI 4)', keyword: 'cathétérisme urétral homme sondage homme' },
      { id: 'tech-sonde-uri-retrait', label: 'Retrait sonde urinaire (AMI 2)', keyword: 'ablation sonde urinaire retrait' },
      { id: 'tech-drain', label: 'Surveillance / retrait drain de Redon (AMI 2,8)', keyword: 'drain de Redon ablation changement flacon surveillance retrait' },
      { id: 'tech-alimentation-enterale', label: 'Pose sonde alimentation entérale (AMI 3)', keyword: 'pose sonde nasogastrique pose sonde gastrique alimentation entérale gastrostomie SNG sonde naso gastrique AMI 3' },
      { id: 'tech-seance-gavage', label: 'Séance d\'alimentation entérale (gavage) — AMI 3', keyword: 'séance alimentation entérale gavage brancher poche nutrition entérale passage quotidien sonde SNG alimentation gastrostomie AMI 3' },
      { id: 'tech-cath-perin', label: 'Séance de surveillance cathéter périnerveux (AMI 4,2)', keyword: 'cathéter périnerveux analgésie' },
      { id: 'tech-dialyse', label: 'Dialyse péritonéale', keyword: 'dialyse péritonéale à domicile' },
    ],
  },
  {
    id: 'soins-specifiques',
    name: 'Soins spécifiques',
    icon: 'ri-medicine-bottle-line',
    items: [
      { id: 'spec-aerosol', label: 'Aérosol', keyword: 'aérosol nébulisation' },
      { id: 'spec-collyre', label: 'Instillation collyre', keyword: 'collyre instillation soin oculaire' },
      { id: 'spec-lavement', label: 'Lavement évacuateur', keyword: 'lavement évacuateur' },
    ],
  },
  {
    id: 'telesoin',
    name: 'Télésoin',
    icon: 'ri-computer-line',
    items: [
      { id: 'tel-suivi-pansement', label: 'Suivi de pansement à distance (TMI 1,6 — 5,04 €)', keyword: 'suivi de pansement distance surveillance plaie tmi 1,6' },
      { id: 'tel-tmi', label: 'TMI — Acte à distance (3,15 €)', keyword: 'teleconsultation telesoin tmi visio consultation a distance' },
      { id: 'tel-tls', label: 'TLS — Accompagnement avec soin prévu (10,00 €)', keyword: 'tls accompagnement teleconsultation' },
      { id: 'tel-tll', label: 'TLL — Accompagnement en lieu dédié (12,00 €)', keyword: 'tll accompagnement teleconsultation lieu dedie' },
      { id: 'tel-tld', label: 'TLD — Accompagnement à domicile hors soin (15,00 €)', keyword: 'tld accompagnement teleconsultation domicile hors soin' },
    ],
  },
];

// Identifiants des forfaits BSI (BSA / BSB / BSC) — utilisés pour détecter un forfait actif
export const BSI_FORFAIT_IDS = ['bsi-bsa', 'bsi-bsb', 'bsi-bsc'];

// Soins de nursing non facturables isolément — déclenchent la demande de forfait BSI
// lorsqu'ils sont sélectionnés sans qu'un forfait (BSA/BSB/BSC) ne soit déjà choisi.
// (La préparation du pilulier se cote BSA à taux plein, comme le forfait BSI — elle ne déclenche pas la popup de forfait.)
export const BSI_PROMPT_CARE_IDS = ['bsi-change'];

// Soins liés au diabète — déclenchent la proposition de la séance hebdomadaire
// de surveillance clinique (>75 ans, AMI 4), souvent oubliée par les IDEL.
export const DIABETE_ACT_IDS = ['diab-glycemie', 'diab-injection', 'diab-insuline-lente', 'diab-insuline-2'];
export const DIABETE_SURVEILLANCE_HEBDO_ID = 'diab-surveillance-hebdo';

// Périodes de la journée (tiroirs Matin / Midi / Soir)
export interface PeriodInfo {
  id: 'matin' | 'midi' | 'soir';
  label: string;
  emoji: string;
  icon: string;
  time: string;
  color: 'amber' | 'orange' | 'rose';
}

export const PERIODS: PeriodInfo[] = [
  { id: 'matin', label: 'Matin', emoji: '🌅', icon: 'ri-sun-line', time: '6h — 12h', color: 'amber' },
  { id: 'midi', label: 'Midi', emoji: '☀️', icon: 'ri-sun-fill', time: '12h — 18h', color: 'orange' },
  { id: 'soir', label: 'Soir', emoji: '🌙', icon: 'ri-moon-line', time: '18h — 23h', color: 'rose' },
];

// Soins les plus récurrents — accès rapide en tête de chaque tiroir
export interface RecurrentCare {
  id: string;
  label: string;
  icon: string;
  hint: string;
}

export const RECURRENT_CARES: RecurrentCare[] = [
  { id: 'inj-sc', label: 'Injection SC', icon: 'ri-syringe-line', hint: 'Héparine / anticoagulant' },
  { id: 'prev-sanguin', label: 'Prise de sang', icon: 'ri-test-tube-line', hint: 'Bilan sanguin' },
  { id: 'prev-glycemie', label: 'Glycémie', icon: 'ri-drop-fill', hint: 'Dextro capillaire' },
  { id: 'surv-administration', label: 'Traitement', icon: 'ri-medicine-bottle-line', hint: 'Administration' },
  { id: 'pans-simple', label: 'Pansement simple', icon: 'ri-heart-pulse-line', hint: 'AMI 2,02' },
];

// Options / Paramètres
export interface OptionToggle {
  id: string;
  label: string;
  icon: string;
  keyword: string; // mot-clé ajouté à la description si activé
  category: 'deplacement' | 'majoration' | 'contexte' | 'patient';
}

export const OPTIONS: OptionToggle[] = [
  // Déplacement — détecté automatiquement (IFD) ou non calculable sans distance (IK)
  // Majorations
  { id: 'opt-mie', label: 'MIE (Enfant < 7 ans)', icon: 'ri-user-smile-line', keyword: 'enfant pédiatrique moins de 7 ans', category: 'majoration' },
  { id: 'opt-nuit', label: 'Nuit (20h-23h / 5h-8h)', icon: 'ri-moon-line', keyword: 'nuit 20h', category: 'majoration' },
  { id: 'opt-nuit-pro', label: 'Nuit profonde (23h-5h)', icon: 'ri-moon-fill', keyword: 'nuit 23h minuit nuit profonde', category: 'majoration' },
  { id: 'opt-dimanche', label: 'Dimanche', icon: 'ri-sun-line', keyword: 'dimanche', category: 'majoration' },
  { id: 'opt-ferie', label: 'Jour férié', icon: 'ri-calendar-event-line', keyword: 'jour férié', category: 'majoration' },

  // Contexte
  { id: 'opt-bsi', label: 'BSI (Bilan de soins)', icon: 'ri-file-list-3-line', keyword: 'BSI bilan de soins infirmiers validé', category: 'contexte' },
  { id: 'opt-urgence', label: 'Urgence', icon: 'ri-alert-line', keyword: 'urgence', category: 'contexte' },
  { id: 'opt-prem-visite', label: 'Première visite', icon: 'ri-door-open-line', keyword: 'première visite', category: 'contexte' },

  // Patient
  { id: 'opt-immunodeprime', label: 'Patient immunodéprimé', icon: 'ri-shield-flash-line', keyword: 'immunodéprimé immunodeprime', category: 'patient' },

];

// Actes BSI (forfaits dépendance)
export interface BSIForfait {
  id: string;
  label: string;
  keyword: string;
  montant: string;
}

export const BSI_FORFAITS: BSIForfait[] = [
  { id: 'bsi-bsa', label: 'BSA — Pilulier', keyword: 'BSA dépendance légère GIR 4', montant: '13,00 €' },
  { id: 'bsi-bsb', label: 'BSB — Intermédiaire', keyword: 'BSB dépendance intermédiaire GIR 3', montant: '18,20 €' },
  { id: 'bsi-bsc', label: 'BSC — Lourd', keyword: 'BSC dépendance lourde GIR 1 GIR 2', montant: '28,70 €' },
];

export const BSI_TYPES = [
  { id: 'bsi-initial', label: 'BSI Initial (DI 2,5 — 25€)', keyword: 'BSI initial première évaluation' },
  { id: 'bsi-renouvellement', label: 'BSI Renouvellement (DI 1,2 — 12€)', keyword: 'BSI renouvellement annuel' },
  { id: 'bsi-intermediaire', label: 'BSI Intermédiaire (DI 1,2 — 12€)', keyword: 'BSI intermédiaire évolution clinique' },
];